import { appleTVPlusItsctParams } from '@/helpers/promotion-helper';

export type QualityTVPlacements = 'TitlePage' | 'SearchPage' | 'HomePage' | 'SearchBox' | 'TitlePage-V1';

type BaseConfig = {
	packageId: number;
	clearName: string;
	technicalName: string;
	shortName?: string;
	icon: string;
	iconWide: string;
	type: 'SVOD' | 'TVOD' | 'FREE' | 'JWTV';
};

// 350
export type AppleTVConfig = BaseConfig & {
	itsctParams: Record<string, string[]>;
};

// 9, 119
export type PrimeConfig = BaseConfig & {
	countries: string[];
	urls: Record<'DEFAULT' | 'V1', Record<string, { freeTrialUrl: string; posterTag: string; isImpact?: boolean }>>;
	default?: string;
};

type QualityTVProviderConfigMap = Record<number, AppleTVConfig | PrimeConfig | BaseConfig>;
// type QualityTVProviderConfigMap = {
// 	350: AppleTVConfig;
// 	2: AppleTVConfig;
// 	9: PrimeConfig;
// 	119: PrimeConfig;
// };

export type QTVPackageIds = number;

export const qualityTVProviderConfig: QualityTVProviderConfigMap = {
	350: {
		/* AppleTV+ */
		packageId: 350,
		clearName: 'AppleTV+',
		technicalName: 'appletvplus',
		shortName: 'atp',
		icon: '/icon/152862153/s100/appletvplus.{format}',
		iconWide: '/icon_wide/322151206/s160/appletvplus.{format}',
		itsctParams: { ...appleTVPlusItsctParams },
		type: 'FREE',
	},
	1853: {
		packageId: 1853,
		clearName: 'Paramount+ AppleTV Channel',
		technicalName: 'appletvparamountplus',
		shortName: 'ppa',
		icon: '/icon/303391391/s100/appletvparamountplus.{format}',
		iconWide: '/icon_wide/322151935/s160/appletvparamountplus.{format}',
		type: 'FREE',
	},
	1854: {
		packageId: 1854,
		clearName: 'AMC+ AppleTV Channel',
		shortName: 'aat',
		technicalName: 'appletvamcplus',
		icon: '/icon/303391393/s100/appletvamcplus.{format}',
		iconWide: '/icon_wide/322151938/s160/appletvamcplus.{format}',
		type: 'FREE',
	},
	642: {
		packageId: 642,
		clearName: 'Studio Canal AppleTV Channel',
		technicalName: 'appletvstudiocanal',
		shortName: 'asp',
		icon: '/icon/311512246/s100/appletvstudiocanal.{format}',
		iconWide: '/icon_wide/322151317/s160/appletvstudiocanal.{format}',
		type: 'FREE',
	},
	// TVOD QTV
	2: {
		/* Itunes QTV - TVOD */
		packageId: 2,
		clearName: 'Apple TV',
		technicalName: 'itunes',
		shortName: 'itu',
		icon: '/icon/190848813/s100/itunes.{format}',
		iconWide: '/icon_wide/322150876/s160/itunes.{format}',
		itsctParams: {
			justwatch_tv_6: ['All Non Prime Countries'],
		},
		type: 'TVOD',
	},
	// TVOD QTV
	// SVOD QTV
	158: {
		/* Viu - SVOD */
		packageId: 158,
		clearName: 'Viu',
		technicalName: 'viu',
		shortName: 'viu',
		icon: '/icon/6918774/s100/viu.{format}',
		iconWide: '/icon_wide/322151007/s160/viu.{format}',
		type: 'SVOD',
	},
	122: {
		/* Hotstar (Disney) - SVOD */
		packageId: 122,
		clearName: 'Hotstar',
		technicalName: 'hotstar',
		shortName: 'hst',
		icon: '/icon/324950024/s100/hotstar.{format}',
		iconWide: '/icon_wide/324950082/s160/hotstar.{format}',
		type: 'SVOD',
	},
	1773: {
		/* SkyShowtine - SVOD */
		packageId: 1773,
		clearName: 'SkyShowtime',
		technicalName: 'skyshowtime',
		shortName: 'sst',
		icon: '/icon/330520548/s100/skyshowtime.{format}',
		iconWide: '/icon_wide/330520553/s160/skyshowtime.{format}',
		type: 'SVOD',
	},
	337: {
		/* Disney+ - SVOD */
		packageId: 337,
		clearName: 'Disney+',
		technicalName: 'disneyplus',
		shortName: 'dnp',
		icon: '/icon/313118777/s100/disneyplus.{format}',
		iconWide: '/icon_wide/322151142/s160/disneyplus.{format}',
		type: 'SVOD',
	},
	// SVOD QTV
	// JWTV QTV
	2285: {
		/* JustWatch TV */
		packageId: 2285,
		clearName: 'JustWatchTV',
		technicalName: 'justwatchtv',
		shortName: 'jwt',
		icon: '/icon/321804885/s100/justwatchtv.{format}',
		iconWide: '/icon_wide/321804964/s160/justwatchtv.{format}',
		type: 'JWTV',
	},
	// JWTV QTV
	9: {
		/* Amazon Prime Video */
		packageId: 9,
		clearName: 'Prime Video',
		technicalName: 'amazonprime',
		shortName: 'amp',
		icon: '/icon/52449539/s100/amazonprime.{format}',
		iconWide: '/icon_wide/322556148/s160/amazonprime.{format}',
		countries: ['US'],
		default: 'https://www.amazon.com/gp/video/offers?tag=justus1ktp-20',
		urls: {
			DEFAULT: {
				DE: {
					freeTrialUrl: 'https://www.amazon.de/gp/video/primesignup?tag=amazon-de-qtv-21',
					posterTag: 'amazon-de-qtv-ti-21',
				},
				AT: {
					posterTag: 'amazon-at-qtv-ti-21',
					freeTrialUrl: 'https://www.amazon.de/gp/video/offers?tag=amazon-at-qtv-ft-21',
				},
				US: {
					posterTag: 'amazon-us-qtv-ti-20',
					freeTrialUrl: 'https://www.amazon.com/gp/video/offers?tag=amazon-us-qtv-ft-20',
				},
			},

			V1: {
				DE: {
					posterTag: 'amazon-de-qtv-tmp-ti-21',
					freeTrialUrl: 'https://www.amazon.de/gp/video/primesignup?tag=amazon-de-qtv-tmp-ft-21',
				},
			},
		},
		type: 'FREE',
	},
	119: {
		/* Amazon Prime Video */
		packageId: 119,
		clearName: 'Prime Video',
		technicalName: 'amazonprimevideo',
		shortName: 'prv',
		icon: '/icon/52449539/s100/amazonprime.{format}',
		iconWide: '/icon_wide/322556148/s160/amazonprimevideo.{format}',
		// countries: ['FR', 'PT', 'MX', 'IE', 'CH', 'NL', 'ES', 'CR', 'AU', 'CA'],
		countries: [],
		default: 'http://primevideo-eu.pxf.io/B095Wy',
		urls: {
			DEFAULT: {
				FR: {
					posterTag: 'amazon-fr-qtv-ti-21',
					freeTrialUrl: 'https://www.primevideo.com/-/fr/offers?tag=amazon-fr-qtv-ft-21',
					isImpact: false,
				},
				PT: {
					posterTag: 'amazon-pt-qtv-ti',
					freeTrialUrl: 'https://primevideo-eu.pxf.io/1rKvQm?subId3=amazon-pt-qtv-ft',
					isImpact: true,
				},
				MX: {
					posterTag: 'amazon-mx-qtv-ti',
					freeTrialUrl: 'https://primevideo-row.pxf.io/XYr3NX?subId3=amazon-mx-qtv-ft',
					isImpact: true,
				},
				IE: {
					posterTag: 'amazon-ie-qtv-ti',
					freeTrialUrl: 'https://primevideo-eu.pxf.io/1rKvQm?subId3=amazon-ie-qtv-ft',
					isImpact: true,
				},
				CH: {
					posterTag: 'amazon-ch-qtv-ti-21',
					freeTrialUrl: 'https://www.primevideo.com/-/fr/offers?tag=amazon-ch-qtv-ft-21',
					isImpact: false,
				},
				NL: {
					posterTag: 'amazon-nl-qtv-ti-21',
					freeTrialUrl: 'https://www.primevideo.com/-/nl/offers?tag=amazon-nl-qtv-ft-21',
					isImpact: false,
				},
				ES: {
					posterTag: 'amazon-es-qtv-ti-21',
					freeTrialUrl: 'https://www.primevideo.com/-/es/offers?tag=amazon-es-qtv-ft-21',
					isImpact: false,
				},
				CR: {
					posterTag: 'amazon-cr-qtv-ti',
					freeTrialUrl: 'https://primevideo-row.pxf.io/XYr3NX?subId3=amazon-cr-qtv-ft',
					isImpact: true,
				},
				AU: {
					posterTag: 'amazon-au-qtv-ti-22',
					freeTrialUrl: 'https://www.primevideo.com/-/en/offers?tag=amazon-au-qtv-ft-22',
					isImpact: false,
				},
				CA: {
					posterTag: 'amazon-ca-qtv-ti-20',
					freeTrialUrl: 'https://www.primevideo.com/-/en/offers?tag=amazon-ca-qtv-ft-20',
					isImpact: false,
				},
			},
			V1: {
				AU: {
					posterTag: 'amazon-AU-qtv-tmp-ti-22',
					freeTrialUrl: 'https://www.primevideo.com/-/en/offers?tag=amazon-au-qtv-tmp-ft-22',
					isImpact: false,
				},
				CA: {
					posterTag: 'amazon-ca-qtv-tmp-ti-20',
					freeTrialUrl: 'https://www.primevideo.com/-/en/offers?tag=amazon-ca-qtv-tmp-ft-20',
					isImpact: false,
				},
			},
		},
		type: 'FREE',
	},
};

export const appleDefaultParams = {
	itsct: 'justwatch_tv_6',
};

// currently we only show QTV where we have ATV+. expect this could change in the future
//for experiment
export const appleQualityTvCountries = Object.values(
	(qualityTVProviderConfig[350] as AppleTVConfig).itsctParams
).flat();
export const primeQualityTvCountries = (qualityTVProviderConfig[9] as PrimeConfig).countries.concat(
	(qualityTVProviderConfig[119] as PrimeConfig).countries
);

export const qualityTvCountries = [
	...new Set(
		Object.values((qualityTVProviderConfig[350] as AppleTVConfig).itsctParams)
			.flat()
			.concat(primeQualityTvCountries)
	),
];

export const compositionIDSuffixByPlacement: Record<QualityTVPlacements, string> = {
	TitlePage: '',
	SearchPage: '-sp',
	HomePage: '-hm',
	SearchBox: '-sb',
	'TitlePage-V1': '-a',
};

export function getItsctParam(country: string, placement: QualityTVPlacements): string {
	switch (placement) {
		case 'TitlePage':
			return (
				Object.entries((qualityTVProviderConfig[350] as AppleTVConfig).itsctParams).find(([_, countries]) =>
					countries.includes(country)
				)?.[0] ?? appleDefaultParams.itsct
			);
		case 'HomePage':
			return 'justwatch_tv_2';
		case 'SearchBox':
			return 'justwatch_tv_8';
		case 'SearchPage':
			return 'justwatch_tv_9';
		default:
			return appleDefaultParams.itsct;
	}
}

export function getCompositionIdPrefix(packageId: QTVPackageIds) {
	if ([9, 119].includes(packageId)) return 'pv';
	if (packageId === 350) return 'qb';
	if (packageId === 2) return 'itu';
	if (packageId === 158) return 'viu';
	if (packageId === 122) return 'hts';
	if (qualityTVProviderConfig[packageId]?.shortName) return qualityTVProviderConfig[packageId].shortName;
	return 'qb';
}
